import { useState } from 'react';

type PopUpState = {
  show: boolean;
  isError: boolean;
};

export function usePopUpAlert() {
  const [popUp, setPopUp] = useState<PopUpState>({ show: false, isError: false });

  const showSuccess = () => setPopUp({ show: true, isError: false });
  const showError = () => setPopUp({ show: true, isError: true });
  const close = () => setPopUp(p => ({ ...p, show: false }));

  return { popUp, showSuccess, showError, close };
}
